export default __webpack_public_path__ + "static/media/he.c8a44024.svg";